module.exports = __webpack_public_path__ + "static/media/available-icon-active.4d869411.svg";